// @flow
import * as classNames from 'classnames';
import * as React from 'react';
import { IValidatorPackage } from '../../Validators';
import PhoneInput from 'react-phone-number-input/max'
import 'react-phone-number-input/style.css'
import CountrySelectNative from '../CountrySelect/CountrySelect'
import getCountryNameFromCode from '../CountrySelect/CountryCodeMap'

import './PhoneField.css';

interface IPhoneFieldProps {
    required?: boolean;
    label: string;
    value: string;
    handleOnCountryChange: React.ChangeEventHandler<HTMLInputElement>;
    handleOnChange: React.ChangeEventHandler<HTMLInputElement>;
    handleOnFocus?: React.FocusEventHandler<HTMLInputElement>;
    handleOnBlur?: React.FocusEventHandler<HTMLInputElement>;
    validators?: IValidatorPackage[];
    labels?: string[];
    defaultCountry: string;
    deferErrors: boolean;
    placeholder: string;
    className: string;
    onCountryCodeChange: React.ChangeEventHandler<HTMLInputElement>;
}

interface IPhoneFieldState {
    touched: boolean;
}

class PhoneField extends React.PureComponent<IPhoneFieldProps, IPhoneFieldState> {
    constructor(props: IPhoneFieldProps) {
        super(props);
        this.state = {
            touched: false
        };
    }

    onCountryChange = (e: string) => {
        this.props.handleOnCountryChange(getCountryNameFromCode(e));
    }

    onChangeInput = (e: SyntheticEvent<HTMLInputElement>) => {
        this.props.handleOnChange(e);
    }

    onBlurInput = (e: SyntheticFocusEvent<HTMLInputElement>) => {
        this.setState({
            touched: true
        });
        this.props.handleOnBlur && this.props.handleOnBlur(e);
    }

    onFocusInput = (e: SyntheticFocusEvent<HTMLInputElement>) => {
        this.props.handleOnFocus && this.props.handleOnFocus(e);
    }

    render() {
        let valid = true;
        let errorMsg = '';
        if (this.props.validators) {
            this.props.validators.forEach((validatorPackage) => {
                if (!valid) {
                    return;
                }
                if (validatorPackage.validator(this.props.value) === false) {
                    valid = false;
                    errorMsg = validatorPackage.errorMessage;
                }
            });
        }
        const showError = !valid && (this.props.deferErrors === false);
        const PhoneFieldClasses = classNames('PhoneField', this.props.className || '', {
            'PhoneField--error': showError
        });

        return (
            <div className={PhoneFieldClasses}>
                <div className={'PhoneField-label'}>
                    {this.props.label}
                    {this.props.required && (
                        <span className={'PhoneField-required'}>{' *'}</span>
                    )}
                </div>
                <form>
                    {this.props.defaultCountry}
                    <PhoneInput
                        placeholder={this.props.placeholder}
                        value={this.props.value}
                        onChange={this.onChangeInput}
                        defaultCountry={this.props.defaultCountry}
                        aria-label={this.props.label}
                        // countries={}
                        countryOptionsOrder={["CA", "US", "CR"]}
                        countrySelectComponent={CountrySelectNative}
                        onCountryChange={this.onCountryChange}
                        reset=''
                        // labels={(this.props.labels) ? this.props.labels : undefined}
                        flagUrl="https://storage.googleapis.com/vault.api.ctrlv.ca/public/static_images/CountryFlags/{XX}.png"
                    />
                    {showError && (
                        <div className={'PhoneField-error'}>{errorMsg}</div>
                    )}
                </form>
            </div>
        );
    }
}

export default PhoneField;
